import React from 'react'
import 'react-toastify/dist/ReactToastify.css'
import {ChartDashboard2} from './Components/ChartDashboard2'

const DashboardPage = (props) => {
  return (
    <div className='card mb-5 mb-xl-10'>
      <div className='card-header border-0'>
        <div className='card-title m-0 w-100'>
          <ChartDashboard2 />
        </div>
      </div>
    </div>
  )
}

export {DashboardPage}
